import { RootState } from 'src/store';

import { IHintListData } from '../hints/types';

export const selectHintsSiteLoading = (state: RootState): boolean => state.hintsSite.isLoading;
export const selectHintsSiteLoaded = (state: RootState): boolean => state.hintsSite.isLoaded;
export const selectHintsSiteData = (state: RootState): IHintListData => state.hintsSite.data;
